import React from "react";

const RTD_URL = "https://www.righttodigital.com";

// Logo is white-on-transparent. `dark` renders it near-black for the light header.
export function Wordmark({ dark = false, height = 26, testId }) {
  return (
    <a
      href={RTD_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2.5 group"
      data-testid={testId}
      aria-label="Right to Digital — opens in a new tab"
    >
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: 4,
          height: height,
          backgroundColor: "var(--rtd-gold)",
          borderRadius: 2,
        }}
      />
      <img
        src="/rtd-logo.png"
        alt="Right to Digital"
        style={{
          height: height,
          width: "auto",
          filter: dark ? "brightness(0) saturate(100%)" : "none",
          transition: "opacity 200ms ease",
        }}
        className="group-hover:opacity-80"
      />
    </a>
  );
}

export default function Header() {
  return (
    <header
      className="sticky top-0 z-40 w-full"
      style={{
        height: 64,
        backgroundColor: "var(--rtd-card)",
        borderBottom: "1px solid var(--rtd-border)",
      }}
      data-testid="site-header"
    >
      <div
        className="mx-auto flex h-full items-center justify-between"
        style={{ maxWidth: 1120, paddingLeft: 24, paddingRight: 24 }}
      >
        <Wordmark dark height={22} testId="header-wordmark-link" />
        <span
          className="hidden sm:inline font-body"
          style={{ fontSize: 13, color: "var(--rtd-text-secondary)" }}
          data-testid="header-tagline"
        >
          Signal Engineering · First-Party Data
        </span>
      </div>
    </header>
  );
}
